/** @jsxImportSource @emotion/react */
import { useMemo } from "react";
import TableWithSkeleton from "tables/common/TableWithSkeleton";
import PropTypes from "prop-types";
import useDeletePhaseRuleMutation from "hookMutation/useDeletePhaseRuleMutation";
import useColumns from "./useColumns";

export default function PhaseRulesTable({ rules, isLoading, onEdit }) {
  const deleteRuleMutation = useDeletePhaseRuleMutation();
  const columns = useColumns();
  const meta = useMemo(
    () => ({
      onEdit,
      deleteRule: deleteRuleMutation.mutate,
    }),
    [onEdit, deleteRuleMutation.mutate],
  );

  return (
    <TableWithSkeleton
      data={rules ?? []}
      columns={columns}
      isLoading={isLoading}
      isFetching={deleteRuleMutation.isLoading}
      getRowId={(row) => row.id}
      meta={meta}
    />
  );
}

PhaseRulesTable.propTypes = {
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      source_variable: PropTypes.string.isRequired,
      rule: PropTypes.oneOf(["exact", "contains"]).isRequired,
      source_value: PropTypes.string.isRequired,
      target_variable: PropTypes.string.isRequired,
      target_value: PropTypes.string,
    }),
  ),
};
